const Qubit = () => {
  return (
    <>
      <footer id="ft-footer" className="footer">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-12 mb-0 mb-md-4 pb-0 pb-md-2">
              <div tabIndex={0}>
                <h4 className="footer-head">Registered Office:</h4>
                <p className="mt-4">
                  <strong>Flattrade Broking Private Limited</strong>
                  <br /> Kochar Technology Park, 6 th Floor, <br /> 1 st Cross Road, Ambattur Industrial
                  Estate,
                  <br /> Ambattur, Chennai – 600058.
                </p>
              </div>
              <div className="store-links">
                <div>
                  <a
                    aria-label="click to download flattrade app from appstore"
                    href="https://apps.apple.com/in/app/flattrade/id1543677587"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img alt="App Store" src="https://flattrade.in/images/home/apple.webp" />
                  </a>
                  <a
                    aria-label="click to download flattrade app from playstore"
                    href="https://play.google.com/store/apps/details?id=com.noren.ftconline"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img alt="Google Play Store" src="https://flattrade.in/images/home/google.webp" />{' '}
                  </a>
                </div>
                <div>
                  <a
                    href="https://flattrade.in/download/FTC_Live_Inv_D_FLATTRADE_2025.8.13-setup.exe"
                    aria-label="click to download flattrade desktop application for windows"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img alt="Windows App" src="https://flattrade.in/images/home/windows.webp" />{' '}
                  </a>
                  <a
                    href="https://web.flattrade.in/#/"
                    aria-label="click to access the flattrade web application"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      tabIndex={0}
                      aria-label="QR code to download flattrade app"
                      alt="Web App"
                      src="https://flattrade.in/images/home/web.webp"
                    />
                  </a>
                </div>
              </div>
              <div className="qr-india-wrap">
                <div className="qr-box">
                  <img alt="Download QR Code" src="/b2b/qubit/instakyc_qr.png" />
                </div>
                <div className="made-in-india">
                  <img alt="India Flag" src="/b2b/qubit/india-flag.png" className="india-flag" />{' '}
                  <span>Made in India • Made for You</span>
                </div>
              </div>
            </div>
            <div className="col-lg-2 col-md-4 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0">
              <h4 className="footer-head">Company</h4>
              <div className="list-unstyled footer-list mt-4">
                <a href="https://flattrade.in/about" className="text-foot">
                  <i className="fa-regular fa-angle-right" /> About
                </a>
                <a href="https://flattrade.in/kosh/" className="text-foot">
                  <i className="fa-regular fa-angle-right"></i> Kosh
                </a>
                <a href="https://novo.flattrade.in/" target="_blank" rel="noreferrer" className="text-foot">
                  <i className="fa-regular fa-angle-right"></i> IPO
                </a>
                <a href="https://flattrade.in/products" className="text-foot">
                  <i className="fa-regular fa-angle-right"></i> Products
                </a>
                <a href="https://flattrade.in/pricing" className="text-foot">
                  <i className="fa-regular fa-angle-right"></i> Pricing
                </a>
                <a href="https://flattrade.in/charges" className="text-foot">
                  <i className="fa-regular fa-angle-right"></i> Charges
                </a>
                <a href="https://flattrade.in/contact" className="text-foot">
                  <i className="fa-regular fa-angle-right"></i> Contact
                </a>
              </div>
            </div>
            <div className="col-lg-3 col-md-4 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0 mid-child">
              <h4 className="footer-head">Useful Links</h4>
              <div className="list-unstyled footer-list mt-4">
                <a href="https://flattrade.in/brokerage-calculator#tab-equities" className="text-foot">
                  <i className="fa-regular fa-angle-right"></i> Brokerage Calculator
                </a>
                <a href="https://flattrade.in/downloads" className="text-foot">
                  <i className="fa-regular fa-angle-right"></i> Downloads
                </a>
                <a href="https://flattrade.in/margin-calculator" className="text-foot">
                  <i className="fa-regular fa-angle-right"></i> Margin Calculator
                </a>
                <a href="https://flattrade.in/fund-transfer" className="text-foot">
                  <i className="fa-regular fa-angle-right"></i> Fund Transfer
                </a>
                <a href="https://flattrade.in/knowledge-center" className="text-foot">
                  <i className="fa-regular fa-angle-right"></i> Knowledge Center
                </a>
                <a href="https://flattrade.in/refer" className="text-foot">
                  <i className="fa-regular fa-angle-right"></i> Refer &amp; Earn
                </a>
                <a href="https://flattrade.in/algotrading" className="text-foot">
                  <i className="fa-regular fa-angle-right"></i> Algo Trading
                </a>
                <a href="https://nri.flattrade.in/" className="text-foot">
                  <i className="fa-regular fa-angle-right"></i> NRI
                </a>
                <a href="https://flattrade.in/downloads#investorCharter" className="text-foot">
                  <i className="fa-regular fa-angle-right"></i> Investor Charter
                </a>
              </div>
            </div>
            <div className="col-lg-3 col-md-4 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0 last-child">
              <div tabIndex={0}>
                <h4 className="footer-head">Quick Contact</h4>
                <p className="mt-4">
                  <strong>Support Number:</strong>
                  <br /> 044-61329696 / 044-35019696
                  <br />
                  <strong>Support Email:</strong> support@flattrade.in{' '}
                </p>
              </div>
              <div className="list-unstyled social-icon social mb-0 mt-4">
                <div className="list-inline-item">
                  <a
                    href="https://www.facebook.com/Flattrade-103462981765387/"
                    target="_blank"
                    className="rounded"
                    rel="noopener noreferrer"
                    aria-label="Flattrade on Facebook"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="feather feather-facebook fea icon-sm fea-social"
                    >
                      <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path>
                    </svg>
                  </a>
                </div>
                <div className="list-inline-item">
                  <a
                    href="https://twitter.com/Flattradein"
                    target="_blank"
                    className="rounded"
                    rel="noopener noreferrer"
                    aria-label="Flattrade on Twitter"
                  >
                    <svg
                      fill="none"
                      height={24}
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      viewBox="0 0 24 24"
                      width={24}
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M18.244 2H21.552L14.33 10.263L22.824 22H16.112L10.828 14.91L4.95 22H1.64L9.36 13.175L1.176 2H8.064L12.844 8.478L18.244 2Z" />
                    </svg>
                  </a>
                </div>
                <div className="list-inline-item">
                  <a
                    href="https://www.linkedin.com/company/flattradein/"
                    target="_blank"
                    className="rounded"
                    rel="noopener noreferrer"
                    aria-label="Flattrade on Linkedin"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="feather feather-linkedin fea icon-sm fea-social"
                    >
                      <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path>
                      <rect x="2" y="9" width="4" height="12"></rect>
                      <circle cx="4" cy="4" r="2"></circle>
                    </svg>
                  </a>
                </div>
                <div className="list-inline-item">
                  <a
                    href="https://www.instagram.com/flattradein/"
                    target="_blank"
                    className="rounded"
                    rel="noopener noreferrer"
                    aria-label="Flattrade on Instagram"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="feather feather-instagram fea icon-sm fea-social"
                    >
                      <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
                      <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
                      <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
                    </svg>
                  </a>
                </div>
                <div className="list-inline-item">
                  <a
                    href="https://www.youtube.com/channel/UCqoiLYmVTt4dsFO4YOBAXuQ/featured"
                    target="_blank"
                    className="rounded"
                    rel="noopener noreferrer"
                    aria-label="Flattrade on Youtube"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="feather feather-youtube fea icon-sm fea-social"
                    >
                      <path d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z"></path>
                      <polygon points="9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02"></polygon>
                    </svg>
                  </a>
                </div>
                <div className="list-inline-item">
                  <a
                    href="https://whatsapp.com/channel/0029Va5e3xX2P59q5v1G8g13"
                    target="_blank"
                    className="rounded"
                    rel="noopener noreferrer"
                    aria-label="Flattrade on Whatsapp"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" fill="currentColor">
                      <path d="M476.9 161.1C435 119.1 379.2 96 319.9 96C197.5 96 97.9 195.6 97.9 318C97.9 357.1 108.1 395.3 127.5 429L96 544L213.7 513.1C246.1 530.8 282.6 540.1 319.8 540.1L319.9 540.1C442.2 540.1 544 440.5 544 318.1C544 258.8 518.8 203.1 476.9 161.1zM319.9 502.7C286.7 502.7 254.2 493.8 225.9 477L219.2 473L149.4 491.3L168 423.2L163.6 416.2C145.1 386.8 135.4 352.9 135.4 318C135.4 216.3 218.2 133.5 320 133.5C369.3 133.5 415.6 152.7 450.4 187.6C485.2 222.5 506.6 268.8 506.5 318.1C506.5 419.9 421.6 502.7 319.9 502.7zM421.1 364.5C415.6 361.7 388.3 348.3 383.2 346.5C378.1 344.6 374.4 343.7 370.7 349.3C367 354.9 356.4 367.3 353.1 371.1C349.9 374.8 346.6 375.3 341.1 372.5C308.5 356.2 287.1 343.4 265.6 306.5C259.9 296.7 271.3 297.4 281.9 276.2C283.7 272.5 282.8 269.3 281.4 266.5C280 263.7 268.9 236.4 264.3 225.3C259.8 214.5 255.2 216 251.8 215.8C248.6 215.6 244.9 215.6 241.2 215.6C237.5 215.6 231.5 217 226.4 222.5C221.3 228.1 207 241.5 207 268.8C207 296.1 226.9 322.5 229.6 326.2C232.4 329.9 268.7 385.9 324.4 410C359.6 425.2 373.4 426.5 391 423.9C401.7 422.3 423.8 410.5 428.4 397.5C433 384.5 433 373.4 431.6 371.1C430.3 368.6 426.6 367.2 421.1 364.5z" />
                    </svg>
                  </a>
                </div>
              </div>
              <div tabIndex={0}>
                <p>
                  Join our{' '}
                  <span className="text-primary font-weight-bold ">
                    <a
                      href="https://t.me/FortuneCapitalServicesPvtLtd"
                      target="_blank"
                      rel="noreferrer"
                      aria-label="click to join our telegram channel"
                    >
                      Telegram Channel
                    </a>
                  </span>{' '}
                  for trading related activities and information.
                </p>
              </div>
              <div className="footer-the-realzero">
                <p>#therealzerobrokerage</p>
              </div>
              <img src="/b2b/qubit/ISO_logo.png" alt="ISO Certified" className="iso-logo" />
            </div>
          </div>
        </div>
        <div className="footer footer-bar">
          <div className="container">
            <div className="row">
              <div className="col-sm-12">
                <div className="text-sm-left text-muted footer-legal">
                  <p tabIndex={0} className="text-justify">
                    Flattrade Broking Private Limited. SEBI Registration No. INZ000201438. Member Code for
                    NSE: 14572 BSE:6524 MCX: 16765. SEBI Single registration no : IN-DP-811-2025. Registered
                    Office: Kochar Technology Park, 6th Floor, SP-31-A, 1st Cross Road, Ambattur Industrial
                    Estate, Ambattur, Chennai – 600 058. For any complaints pertaining to stock broking please
                    write to ftc@ftconline.in and for DP related to dp@ftconline.in Please ensure to read the
                    Risk Disclosure Document carefully as prescribed by SEBI.
                  </p>
                  <div tabIndex={0}>
                    <p className="text-justify">
                      “Procedure to file a complaint on SEBI SCORES: Register on{' '}
                      <a
                        aria-label="SEBI SCORES"
                        href="https://scores.sebi.gov.in/"
                        target="_blank"
                        rel="noreferrer"
                        className=""
                      >
                        SCORES
                      </a>{' '}
                      portal. Mandatory details for filing complaints on SCORES: Name, PAN, Address, Mobile
                      Number, E-mail ID. Benefits: Effective Communication, Speedy redressal of the
                      grievances&quot;{' '}
                    </p>
                  </div>
                  <p tabIndex={0} className="text-justify">
                    &quot;Prevent unauthorised transactions in your account, update your mobile numbers/email
                    IDs with your Stockbroker/Depository Participant. Receive information of your transactions
                    directly from Exchange/Depository on your mobile/ email at the end of the day. Issued in
                    the interest of investors&quot;. As a business we do not give stock tips and have not
                    authorized anyone to trade on behalf of others. If you find anyone claiming to be part of
                    FLATTRADE and offering such services, please email to ftc@ftconline.in. &quot;KYC is one
                    time exercise while dealing in securities markets - once KYC is done through a SEBI
                    registered intermediary (broker, DP, Mutual Fund etc.), you need not undergo the same
                    process again when you approach another intermediary.&quot; Dear Investor, if you are
                    subscribing to an IPO, there is no need to issue a cheque. Please write the Bank account
                    number and sign the IPO application form to authorize your bank to make payment in case of
                    allotment. In case of non-allotment, the funds will remain in your bank account.
                  </p>
                  <div tabIndex={0}>
                    <p className="text-justify">
                      {' '}
                      &quot;Attention Investors 1. Stock Brokers can accept securities as margin from clients
                      only by way of pledge in the depository system w.e.f. September 1, 2020. 2.Update your
                      mobile number &amp; email Id with your stock broker/depository participant and receive
                      OTP directly from depository on your email id and/or mobile number to create pledge. 3.
                      Pay 20% upfront margin of the transaction value to trade in cash market segment 4.
                      Investors may please refer to the Exchange\&apos;s Frequently Asked Questions (FAQs)
                      issued vide circular reference NSE/INSP/45191 dated July 31, 2020 and NSE/INSP/45534
                      dated August 31, 2020 and other guidelines issued from time to time in this regard. 5.
                      Check your Securities /MF/ Bonds in the consolidated account statement issued by
                      NSDL/CDSL every month. Issued in the interest of Investors&quot;. To read Advisory for
                      investors,{' '}
                      <a
                        aria-label="click here To read Advisory for investors"
                        data-bs-toggle="modal"
                        data-bs-target="#termsModal"
                        className=""
                      >
                        click here
                      </a>
                      . 6. Investors are requested to note that Stock broker (Flattrade Broking Private
                      Limited is permitted to receive/pay money from/to investor through designated bank
                      accounts only named as client bank accounts. Stock broker (Flattrade Broking Private
                      Limited) is also required to disclose these client bank accounts to Stock Exchange.
                      Hence, you are requested to use following client bank accounts only for the purpose of
                      dealings in your trading account with us. The details of these client bank accounts are
                      also displayed by NSE on their website under &quot;Know/ Locate your Stock Broker&quot;
                      and for MCX &quot;Membership→Notice Board→Member &amp; AP Details&quot;. To know client
                      bank account{' '}
                      <a
                        aria-label="click here  To know client bank account "
                        data-bs-toggle="modal"
                        data-bs-target="#termsModal2"
                        className=""
                      >
                        click here
                      </a>
                      .
                    </p>
                  </div>
                  <div tabIndex={0}>
                    <p className="text-justify">
                      Risk disclosure for Futures and Options clients{' '}
                      <a
                        data-bs-toggle="modal"
                        data-bs-target="#termsModal3"
                        aria-label="click here to view Risk disclosure for Futures and Options clients "
                      >
                        click here
                      </a>
                      .
                    </p>
                  </div>
                  <p tabIndex={0} className="text-justify">
                    Disclaimer: &apos;Investment in securities market are subject to market risks, read all
                    the related documents carefully before investing&apos;.
                    <br />
                    &quot;Investment in Mutual Fund market are subject to market risk. There is no guaranteed
                    or assured rate of return. Past Performance is not indication of future returns. Please
                    read all related documents carefully before investing&quot;.
                    <br />
                    &quot;The securities quoted are exemplary and are not recommendatory&quot;.
                    <br />
                    &quot;Brokerage will not exceed the SEBI prescribed limit&quot;.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer footer-bar">
          <div className="container text-center">
            <div className="row">
              <div className="col-12">
                <div className="footer-copy-rights">
                  <p className="text-center text-md-start">© 2026. Flattrade Broking Private Limited. </p>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <div className="text-center text-md-end footer-end-link">
                  <ul>
                    <li className="list-inline-item">
                      <i className="fa-solid fa-caret-up"></i>
                      <a
                        href="https://evoting.cdslindia.com/Evoting/EvotingLogin"
                        target="_blank"
                        rel="noreferrer"
                        className="text-foot"
                      >
                        {' '}
                        e-Voting
                      </a>
                    </li>
                    <li className="list-inline-item">
                      <i className="fa-solid fa-caret-up"></i>
                      <a
                        href="https://www.nseindia.com/"
                        target="_blank"
                        rel="noreferrer"
                        className="text-foot"
                      >
                        {' '}
                        NSE
                      </a>
                    </li>
                    <li className="list-inline-item">
                      <i className="fa-solid fa-caret-up"></i>
                      <a
                        href="https://www.bseindia.com/"
                        target="_blank"
                        rel="noreferrer"
                        className="text-foot"
                      >
                        {' '}
                        BSE
                      </a>
                    </li>
                    <li className="list-inline-item">
                      <i className="fa-solid fa-caret-up"></i>
                      <a
                        href="https://www.mcxindia.com/"
                        target="_blank"
                        rel="noreferrer"
                        className="text-foot"
                      >
                        {' '}
                        MCX
                      </a>
                    </li>
                    <li className="list-inline-item">
                      <i className="fa-solid fa-caret-up"></i>
                      <a
                        href="https://www.cdslindia.com/index.html"
                        target="_blank"
                        rel="noreferrer"
                        className="text-foot"
                      >
                        {' '}
                        CDSL
                      </a>
                    </li>
                    <li className="list-inline-item">
                      <i className="fa-solid fa-caret-up"></i>
                      <a
                        href="https://www.sebi.gov.in/"
                        target="_blank"
                        rel="noreferrer"
                        className="text-foot"
                      >
                        {' '}
                        SEBI
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12">
                <div className="text-center text-md-end footer-end-link">
                  <ul>
                    <li className="list-inline-item">
                      <i className="fa-solid fa-caret-up"></i>
                      <a href="https://flattrade.in/sitemap" className="text-foot">
                        {' '}
                        Sitemap
                      </a>
                    </li>
                    <li className="list-inline-item">
                      <i className="fa-solid fa-caret-up"></i>
                      <a href="https://flattrade.in/terms" className="text-foot">
                        {' '}
                        Terms &amp; Conditions
                      </a>
                    </li>
                    <li className="list-inline-item">
                      <i className="fa-solid fa-caret-up"></i>
                      <a href="https://flattrade.in/privacy" className="text-foot">
                        {' '}
                        Privacy Policy
                      </a>
                    </li>
                    <li className="list-inline-item">
                      <i className="fa-solid fa-caret-up"></i>
                      <a href="https://flattrade.in/disclaimer" className="text-foot">
                        {' '}
                        Disclaimer
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-sm-12">
                <div className="text-center text-md-end footer-end-link">
                  <ul>
                    <li className="list-inline-item">
                      <i className="fa-solid fa-caret-up"></i>
                      <a href="https://flattrade.in/kosh/flattrade-system-status/" className="text-foot">
                        {' '}
                        System Status
                      </a>
                    </li>
                    <li className="list-inline-item">
                      <i className="fa-solid fa-caret-up"></i>
                      <a href="https://flattrade.in/fraud-prevention" className="text-foot">
                        {' '}
                        Fraud Prevention
                      </a>
                    </li>
                    <li className="list-inline-item">
                      <i className="fa-solid fa-caret-up"></i>
                      <a href="https://flattrade.in/mandatory-member-details" className="text-foot">
                        {' '}
                        Mandatory Member Details
                      </a>
                    </li>
                    <li className="list-inline-item">
                      <i className="fa-solid fa-caret-up"></i>
                      <a
                        href="https://investor.sebi.gov.in/iscs_contacts.html"
                        target="_blank"
                        rel="noreferrer"
                        className="text-foot"
                      >
                        {' '}
                        Common ISC Centers
                      </a>
                    </li>
                    <li className="list-inline-item">
                      <i className="fa-solid fa-caret-up"></i>
                      <a
                        href="https://investorhelpline.nseindia.com/ClientCollateral"
                        target="_blank"
                        rel="noreferrer"
                        className="text-foot"
                      >
                        {' '}
                        Client Collateral Details
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <div className="modal fade" id="loginModal" tabIndex={-1}>
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="loginModalLabel">
                Please choose the application to login
              </h5>
              <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body login-cols-modal-body text-center">
              <div className="row login-rows">
                <div className="col-md-6 login-cols">
                  <a href="https://web.flattrade.in/#/" target="_blank" rel="noreferrer">
                    <i className="fas fa-chart-line fa-2x"></i>
                    <br />
                    Web Trading
                  </a>
                </div>
                <div className="col-md-6 login-cols">
                  <a href="https://bo.ftconline.in/" target="_blank" rel="noreferrer">
                    <i className="fas fa-file-invoice fa-2x"></i>
                    <br />
                    Backoffice
                  </a>
                </div>
              </div>
              <div className="row login-rows">
                <div className="col-md-6 login-cols">
                  <a href="https://ipo.ftconline.in:8084/IPOWEB/Index" target="_blank" rel="noreferrer">
                    <i className="fas fa-bullhorn fa-2x"></i>
                    <br />
                    IPO
                  </a>
                </div>
                <div className="col-md-6 login-cols">
                  <a href="https://wall.flattrade.in/myAccount" target="_blank" rel="noreferrer">
                    <i className="fas fa-user-edit fa-2x"></i>
                    <br />
                    Manage Your Account
                  </a>
                </div>
              </div>
            </div>
            <div className="modal-footer" style={{ justifyContent: 'center' }}>
              <h6 className="text-left">Download Our Trading App</h6>
              <div className="row text-center">
                <div className="col-md-4 col-sm-4 col-4 mb-2">
                  <a
                    href="https://apps.apple.com/in/app/flattrade/id1543677587"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      src=""
                      className="img-fluid"
                      alt="Download the FLATTRADE app on your IOS devices"
                      title="Download the FLATTRADE app on your IOS devices"
                    />
                  </a>
                </div>
                <div className="col-md-4 col-sm-4 col-4">
                  <a
                    href="https://play.google.com/store/apps/details?id=com.noren.ftconline"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      src="/b2b/qubit/google.webp"
                      className="img-fluid"
                      alt="Download the FLATTRADE app on your Android devices"
                      title="Download FLATTRADE app on Android"
                    />
                  </a>
                </div>
                <div className="col-md-4 col-sm-4 col-4">
                  <a
                    href="https://flattrade.in/download/FTC_Live_Inv_D_FLATTRADE_2025.8.13-setup.exe"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      src="/b2b/qubit/window.png"
                      className="img-fluid"
                      alt="Download the FLATTRADE app on your Winows devices"
                      title="Download FLATTRADE app on Windows"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="modal fade" id="termsModal">
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content ">
            <div className="modal-header">
              <h5 className="modal-title " id="loginModalLabel">
                Attention Investors!
              </h5>
              <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <ul style={{ fontSize: '12px' }}>
                <li>
                  Beware of fixed/guaranteed/regular returns/ capital protection schemes. Brokers or their
                  authorized persons or any of their associates are not authorized to offer
                  fixed/guaranteed/regular returns/ capital protection on your investment or authorized to
                  enter into any loan agreement with you to pay interest on the funds offered by you. <br />
                  Please note that in case of default of a member claim for funds or securities given to the
                  broker under any arrangement/ agreement of indicative return will not be accepted by the
                  relevant Committee of the Exchange as per the approved norms.
                </li>
                <li>
                  Do not keep funds idle with the Stock Broker. Please note that your stock broker has to
                  return the credit balance lying with them, within three working days in case you have not
                  done any transaction within last 30 calendar days. Please note that in case of default of a
                  Member, claim for funds and securities, without any transaction on the exchange will not be
                  accepted by the relevant Committee of the Exchange as per the approved norms.
                </li>
                <li>
                  Check the frequency of accounts settlement opted for. If you have opted for running account,
                  please ensure that your broker settles your account and, in any case, not later than once in
                  90 days (or 30 days if you have opted for 30 days settlement). In case of declaration of
                  trading member as defaulter, the claims of clients against such defaulter member would be
                  subject to norms for eligibility of claims for compensation from IPF to the clients of the
                  defaulter member. These norms are available on Exchange website at following link:{' '}
                  <a
                    href="https://www.nseindia.com/invest/about-defaulter-section"
                    target="_blank"
                    rel="noreferrer"
                  >
                    NSC
                  </a>
                  ,{' '}
                  <a
                    href="https://www.mcxindia.com/docs/default-source/investor-grievance-arbitration/defaulters/norms-on-rejections-of-claims/sop-process-faqs-for-handling-of-claims-of-investors-of-defaulter-member.pdf?sfvrsn=b5737291_6"
                    target="_blank"
                    rel="noreferrer"
                  >
                    MCX
                  </a>
                </li>
                <li>
                  Brokers are not permitted to accept transfer of securities as margin. Securities offered as
                  margin/ collateral MUST remain in the account of the client and can be pledged to the broker
                  only by way of ‘margin pledge’, created in the Depository system. Clients are not permitted
                  to place any securities with the broker or associate of the broker or authorized person of
                  the broker for any reason. Broker can take securities belonging to clients only for
                  settlement of securities sold by the client.
                </li>
                <li>
                  Always keep your contact details viz. Mobile number/Email ID updated with the stock broker.
                  Email and mobile number is mandatory and you must provide the same to your broker for
                  updation in Exchange records. You must immediately take up the matter with Stock
                  Broker/Exchange if you are not receiving the messages from Exchange/Depositories regularly.
                </li>
                <li>
                  Don\&apos;t ignore any emails/SMSs received from the Exchange for trades done by you. Verify
                  the same with the Contract notes/Statement of accounts received from your broker and report
                  discrepancy, if any, to your broker in writing immediately and if the Stock Broker does not
                  respond, please take this up with the Exchange/Depositories forthwith.
                </li>
                <li>
                  Check messages sent by Exchanges on a weekly basis regarding funds and securities balances
                  reported by the trading member, compare it with the weekly statement of account sent by
                  broker and immediately raise a concern to the exchange if you notice a discrepancy.
                </li>
                <li>
                  Please do not transfer funds, for the purposes of trading to anyone, including an authorized
                  person or an associate of the broker, other than a SEBI registered Stock broker.
                </li>
                <li>
                  Do not deal with unregistered intermediaries (who are not registered with SEBI/Exchanges).
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="termsModal2"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="termsModal2Label"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content ">
            <div className="modal-header">
              <h5 className="modal-title " id="loginModalLabel"></h5>
              <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body table-responsive">
              <table className="table globalTable">
                <thead>
                  <tr>
                    <th> Bank Account No. </th>
                    <th> IFSC </th>
                    <th> Bank Account Type </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td> &quot;059485700000129&quot; </td>
                    <td> YESB0000594 </td>
                    <td> Up Streaming Client Nodal Bank Account </td>
                  </tr>
                  <tr>
                    <td> &quot;01660340001487&quot; </td>
                    <td> HDFC0000166 </td>
                    <td> Up Streaming Client Nodal Bank Account </td>
                  </tr>
                  <tr>
                    <td> &quot;039505008960&quot; </td>
                    <td> ICIC0000395 </td>
                    <td> Up Streaming Client Nodal Bank Account </td>
                  </tr>
                  <tr>
                    <td> &quot;01660340001512&quot; </td>
                    <td> HDFC0000166 </td>
                    <td> Up Streaming Client Nodal Bank Account </td>
                  </tr>
                  <tr>
                    <td> &quot;01660340001470&quot; </td>
                    <td> HDFC0000166 </td>
                    <td> Up Streaming Client Nodal Bank Account </td>
                  </tr>
                  <tr>
                    <td> &quot;2221262044881111&quot; </td>
                    <td> AUBL0002620 </td>
                    <td> Up Streaming Client Nodal Bank Account </td>
                  </tr>
                  <tr>
                    <td> &quot;01660340001460&quot; </td>
                    <td> HDFC0000166 </td>
                    <td> Up Streaming Client Nodal Bank Account </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div
        className="fade modal"
        role="dialog"
        aria-hidden={true}
        aria-labelledby="termsModal3Label"
        id="termsModal3"
        tabIndex={-1}
      >
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h2 className="modal-title" id="loginModalLabel">
                Annexure-I: Risk disclosures
              </h2>
              <button aria-label="Close" className="close" data-bs-dismiss="modal" type="button">
                <span aria-hidden={true}>×</span>
              </button>
            </div>
            <div className="modal-body table-responsive">
              <table className="globalTable table">
                <thead>
                  <tr>
                    <th>RISK DISCLOSURES ON DERIVATIVES</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <ul>
                        <li>
                          9 out of 10 individual traders in equity Futures and Options Segment, incurred net
                          losses.
                        </li>
                        <li>On an average, loss makers registered net trading loss close to ₹ 50,000.</li>
                        <li>
                          Over and above the net trading losses incurred, loss makers expended an additional
                          28% of net trading losses as transaction costs.
                        </li>
                        <li>
                          Those making net trading profits, incurred between 15% to 50% of such profits as
                          transaction cost.
                        </li>
                      </ul>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div>
              <h4 className="modal-title" id="loginModalLabel">
                Source:
              </h4>
              <a href="https://www.sebi.gov.in/reports-and-statistics/research/jan-2023/study-analysis-of-profit-and-loss-of-individual-traders-dealing-in-equity-fando-segment_67525.html">
                <ol>
                  <li>
                    SEBI study dated January 25, 2023 on &quot;Analysis of Profit and Loss of Individual
                    Traders dealing in equity Futures and Options (F&amp;O) Segment&quot;, wherein Aggregate
                    Level findings are based on annual Profit/Loss incurred by individual traders in equity
                    F&O during FY 2021-22.
                  </li>
                </ol>
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Qubit;
